import { Atmos } from '@/apis/atmos'

export default {
    async init(context) {
        //are we already initialized?
        if (context.state.atmosInitialized)
            return;

        //setup the application types
        var types = await Atmos.getApplicationTypes();
        var lookup = {};
        types.map(i => {
            var item = lookup[i.name];
            if (!item) {
                item = { name: i.name, versions: [] };
                lookup[i.name] = item;
            }
            item.versions.push(i);
        });
        
        Object.keys(lookup).forEach(k => lookup[k].versions.sort((a,b) => b.version.localeCompare(a.version)));

        Object.keys(lookup).forEach(k => {
            let item = lookup[k];
            item.description = item.versions[0].description;
            item.hidden = item.versions[0].hidden;
        })

        context.commit('ATMOS_POPULATE_APPTYPES', lookup);

        //setup subscriptions
        var subs = await Atmos.getSubscriptions();
        context.commit('ATMOS_POPULATE_SUBSCRIPTIONS', subs);
        if (subs.length > 0) {
            context.dispatch('atmosChangeSubscription', subs[0])
        }

        //setup the poll of app instances
        setInterval(() => {
            context.dispatch('atmosRefreshApps');
        }, 30000);
    },

    async atmosChangeSubscription(context, sub) {
        context.commit('ATMOS_CHANGE_SUBSCRIPTION', sub);
        context.dispatch('atmosRefreshApps');
    },

    updateShowPrereleases(context, flag) {
        context.commit('ATMOS_UPDATE_SHOWPRERELEASES', flag);
    },

    updateShowVersions(context, flag) {
        context.commit('ATMOS_UPDATE_SHOWVERSIONS', flag);
    },

    async atmosRefreshApps(context) {
        context.commit('ATMOS_CLEAR_APPS');
        var apps = await Atmos.getApplicationInstances(context.state.atmosSubscription.id)
        context.commit('ATMOS_POPULATE_APPS', apps);
    },

    async atmosAddSubscription(context, { name, sn, desc }) {
        var sub = await Atmos.addSubscription(name, sn, desc);
        context.commit('ATMOS_ADD_SUBSCRIPTION', sub);
    },

    async atmosUpdateSubscription(context, { id, name, sn, desc }) {
        var sub = await Atmos.updateSubscription(id, name, sn, desc);
        context.commit('ATMOS_UPDATE_SUBSCRIPTION', sub);
        return sub;
    },

    async atmosAddApplication(context, { sub, type, version, name, expiresOn, parameters }) {
        await Atmos.addApplicationInstance(sub, type, version, name, expiresOn, parameters);
        context.dispatch('atmosRefreshApps');
    },

    async atmosUpgradeApplication(context, { name, version, parameters }) {
        await Atmos.upgradeApplicationInstance(name, version, parameters);
        context.dispatch('atmosRefreshApps');
    },

    async atmosRemoveApplication(context, name) {
        await Atmos.removeApplicationInstance(name);
        context.dispatch('atmosRefreshApps');
    },

    async atmosUndeployApplication(context, name) {
        await Atmos.undeployApplicationInstance(name);
        context.dispatch('atmosRefreshApps');
    },

    async atmosDeployApplication(context, name) {
        await Atmos.deployApplicationInstance(name);
        context.dispatch('atmosRefreshApps');
    },
}